import { CatalogDomain } from "../types/enums/CatalogDomain";
import {
  CatalogPolicy,
  CatalogPolicyOverrides,
  catalogDomainPolicyKey,
  CatalogDomainPolicy,
  defaultCatalogPolicy,
} from "../types/catalogPolicy";
import { CatalogOverridableField } from "../types/enums/CatalogOverridableField";
import { UserRole } from "../types/enums/UserRole";
import { ChainId, ResellerId } from "../types/ids";

export const resolveDomainPolicy = (
  chainPolicy: CatalogPolicy | undefined,
  storeOverrides: CatalogPolicyOverrides | undefined,
  domain: CatalogDomain,
): CatalogDomainPolicy => {
  const policy = chainPolicy ?? defaultCatalogPolicy;
  const key = catalogDomainPolicyKey[domain];
  const storeOverride = storeOverrides?.[key];
  if (storeOverride) {
    return {
      ...policy[key],
      ...storeOverride,
    };
  }
  return policy[key];
};

export const isFieldOverridable = (
  domainPolicy: CatalogDomainPolicy,
  field: `${CatalogOverridableField}`,
): boolean => {
  const overridableFields = domainPolicy.overridableFields ?? [];
  return overridableFields.some(
    (overridableField) => overridableField === field,
  );
};

export const hasChainCatalogAccess = (
  user:
    | {
        role: UserRole;
        resellerId?: ResellerId | null;
        chainIds?: ChainId[];
      }
    | null
    | undefined,
  store: { chainId: ChainId; resellerId?: ResellerId | null },
): boolean =>
  user?.role === UserRole.ADMIN ||
  (user?.role === UserRole.RESELLER_ADMIN &&
    user.resellerId != null &&
    store.resellerId != null &&
    user.resellerId === store.resellerId) ||
  (user?.chainIds?.includes(store.chainId) ?? false);
